import { useState as r } from "react";
const b = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: n,
  onChangeCountry: u
}) => {
  const [h, s] = r(e), [a, i] = r(t);
  return {
    phoneNumber: h,
    country: a,
    handlePhoneNumberChange: (o) => {
      s(o), n?.(o);
    },
    handleCountryChange: (o) => {
      i(o), u?.(o);
    }
  };
}, d = ["invalid_phone_number", "invalid_country_code", "too_short", "too_long", "invalid_phone_number"], _ = () => {
  const [e, t] = r(null), [n, u] = r(!1);
  return {
    errorCode: e,
    setErrorCode: t,
    isValidPhoneNumber: n,
    setIsValidPhoneNumber: u,
    checkPhoneNumberValidity: () => {
      if (!n) {
        const h = e === null ? void 0 : d[e] || "invalid_phone_number";
        return { isValidPhoneNumber: n, errorCode: e, errorKey: h };
      }
      return { isValidPhoneNumber: n };
    }
  };
};
export {
  b as usePhoneNumber,
  _ as usePhoneNumberValidation
};
